import http from "../../services/http-client";
import { CASH_CENTER_TYPES } from "./constants";

const API_URL = process.env.REACT_APP_API_URL;
export const modifyCashCenterPayload = (
  cashCenter,
  currencies,
  countries,
  cashCenterId
) => {
  const getType = () => {
    const index = CASH_CENTER_TYPES.findIndex(
      (elm) => elm.value === cashCenter.type
    );
    if (index !== -1) {
      return CASH_CENTER_TYPES[index];
    }
    return cashCenter.type;
  };
  const getCurrency = (curr) => {
    const index = currencies.findIndex((elm) => elm.shortName === curr);
    if (index !== -1) {
      return currencies[index];
    }
    return {
      shortName: curr,
      name: curr,
    };
  };
  const getCountry = (curr) => {
    const index = countries.findIndex((elm) => elm.name === curr);
    if (index !== -1) {
      return countries[index];
    }
    return {
      code: curr,
      name: curr,
    };
  };

  const _cashCenter = {
    id: cashCenterId,
    name: cashCenter.name,
    type: cashCenter.type,
    primaryCurrency: cashCenter.primaryCurrency,
    barcode: cashCenter.barcode,
    locationId: cashCenter.locationId,
    status: cashCenter.status,
    longitude: cashCenter.longitude || "0",
    latitude: cashCenter.latitude || "0",
    loadingBayArea: cashCenter.loadingBayArea,
    loadingBayCapacity: cashCenter.loadingBayCapacity,
    country: cashCenter.country,
    state: cashCenter.state,
    emirate: cashCenter.emirate,
    city: cashCenter.city,
    postalCode: cashCenter.postalCode,
    address: cashCenter.address,
    firstServiceDate: cashCenter.firstServiceDate
      ? new Date(cashCenter.firstServiceDate)
      : null,
    inactiveDate: cashCenter.inactiveDate
      ? new Date(cashCenter.inactiveDate)
      : null,
    serviceDays: cashCenter.serviceDays,
    offices: cashCenter.offices.map((office) => ({
      expanded: false,
      officeId: office.officeId,
      officeName: office.officeName,
      officeType: office.officeType,
      country: office.country,
      state: office.state,
      emirate: office.emirate,
      city: office.city,
      postalCode: office.postalCode,
      address: office.address,
      barcode: office.barcode,
      startDate: office.startDate ? new Date(office.startDate) : null,
      inactiveDate: office.inactiveDate ? new Date(office.inactiveDate) : null,
      status: office.status,
      longitude: office.longitude,
      latitude: office.latitude,
      operationalWindows: office.operationalWindows.map((elm) => ({
        startDateTime: elm.startDateTime ? new Date(elm.startDateTime) : null,
        endDateTime: elm.startDateTime ? new Date(elm.cutOffTime) : null,
        cutOffTime: elm.startDateTime ? new Date(elm.cutOffTime) : null,
      })),
    })),
    operationalWindows: cashCenter.operationalWindows.map((elm) => ({
      startDateTime: elm.startDateTime ? new Date(elm.startDateTime) : null,
      endDateTime: elm.startDateTime ? new Date(elm.cutOffTime) : null,
      cutOffTime: elm.startDateTime ? new Date(elm.cutOffTime) : null,
    })),
    insuranceLimits: cashCenter.insuranceLimits.map((elm) => ({
      customerId: elm.customerId,
      currency: elm.currency,
      area: elm.area,
      limit: elm.limit,
    })),
    contactPersons: cashCenter.contactPersons,
    escalationGroups: cashCenter.escalationGroups.map((group) => {
      const item = {
        region: group.region,
        routeNo: group.routeNo,
        escalationLevel: group.escalationLevel,
        inAppRecipients: group.inAppRecipients.map((elm) => ({ item: elm })),
        emailRecipients: group.emailRecipients.map((elm) => ({ item: elm })),
        callRecipients: group.callRecipients.map((elm) => ({ item: elm })),
      };
      // http
      //   .get(`${API_URL}/lookups/routes/region/${group.region}`)
      //   .then((res) => {
      //     item.routeNo =
      //       res.data.find((elm) => elm.routeNo === group.routeNo) || "";
      //   });
      return item;
    }),
    internalSLAs: cashCenter.internalSLAs.map((elm) => ({
      region: elm.region,
      serviceType: elm.serviceType,
      activityType: elm.activityType,
      responseTime: elm.responseTime,
      attendedTime: elm.attendedTime,
      resolutionTime: elm.resolutionTime,
    })),
  };

  return _cashCenter;
};
